var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loader-outer"}},[_c('ring-loader',{attrs:{"size":'150px'}}),_vm._v(" "),_c('div',{staticClass:"loading-text"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('span',{staticStyle:{"margin-top":"33px"}},[_c('pulse-loader',{attrs:{"size":'10px'}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d047dca","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/helpers/Loader.vue
// module id = 1711
// module chunks = 1